module.exports = __webpack_public_path__ + "static/img/clause_letter101.0de001d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter101.png
// module id = 7ziv
// module chunks = 1